import { render, staticRenderFns } from "./LiveTransmitEvento.vue?vue&type=template&id=2b1e65f6&"
import script from "./LiveTransmitEvento.vue?vue&type=script&lang=js&"
export * from "./LiveTransmitEvento.vue?vue&type=script&lang=js&"
import style0 from "./LiveTransmitEvento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports